import React from 'react';

const GlobalStyles = () => (
  <style>{`
    body {
      font-family: 'Inter', sans-serif;
      background-color: #F4EFEC;
      color: #3a3a3a;
    }
    .modal-overlay {
      position: fixed;
      inset: 0;
      background-color: rgba(0, 0, 0, 0.6);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1rem;
      transition: opacity 0.3s ease;
      z-index: 50;
    }
    .status-ok { background-color: #e9e9e9; color: #6b7280; }
    .status-estoque-baixo { background-color: #D7BFBD; color: #5c3e3c; }
    .status-validade-proxima { background-color: #F2DFDB; color: #a17772; }
    .status-fora-de-validade { background-color: #FF746C; color: #ffffff; }
    .status-esgotado { background-color: #6b7280; color: #ffffff; }
    .type-venda { background-color: #dcfce7; color: #166534; }
    .type-presente { background-color: #FF746C; color: #ffffff; }
    .chart-container {
      position: relative;
      width: 100%;
      height: 300px;
      max-height: 350px;
    }
    .custom-button {
      background-color: #D7BFBD;
      color: #3a3a3a;
      transition: background-color 0.3s;
    }
    .custom-button:hover {
      background-color: #c9a9a6;
    }
    .custom-button:disabled {
      background-color: #e2d6d5;
      cursor: not-allowed;
    }
    .form-label {
      display: block;
      margin-bottom: 0.5rem;
      font-size: 0.875rem;
      font-weight: 500;
      color: #4a4a4a;
    }
    .nav-button {
      transition: all 0.2s;
      border-bottom: 2px solid transparent;
    }
    .nav-button.active {
      border-bottom-color: #D7BFBD;
      color: #3a3a3a;
    }
    .nav-button:not(.active) {
      color: #9B9A98;
    }
    .sortable-header {
      cursor: pointer;
    }
    .sortable-header:hover {
      color: #000;
    }
    .action-btn {
      background: none;
      border: none;
      cursor: pointer;
      padding: 0.25rem;
      font-size: 1.25rem;
      opacity: 0.6;
      transition: opacity 0.2s;
    }
    .action-btn:hover {
      opacity: 1;
    }
    .delete-btn:hover {
      color: #c62828;
    }
    .edit-btn:hover {
      color: #0284c7;
    }
  `}</style>
);

export default GlobalStyles;
